<template>
  <div @mouseleave="$emit('close-tool-tip', false)" class="tool-tip">{{ text }}</div>
</template>

<script>
export default {
  props: ["text"],
};
</script>

<style lang="scss" scoped>
.tool-tip {
  position: absolute;
  top: 50%;
  left: 50%;
  z-index: 100;
  transform: translate(-50%, -50%);
  width: 500px;
  padding: 30px;
  border-radius: 5px;
  background: #333333ec;
  color: #fff;
  box-shadow: 0 0 8px 5px #666666af;
  text-align: center;
}

@media screen and (max-width: 760px) {
  .tool-tip {
    top: 95%;
    transform: translate(-50%, -100%);
    width: 85%;
    padding: 20px 10px;
  }
}
</style>